import axios, { AxiosResponse } from 'axios';
import * as utils from '@/apis/apiUtils';
import {
  JohaisetsuEnsuiPlantParams,
  UpdateMaxEnkaNatoriumuQuantityParams,
  UpdateMaxEnsuiQuantityParams,
} from '@/models/apis/ensui/johaisetsuEnsuiPlantRequest';
import {
  EnsuiPlant,
  UpdateMaxEnkaNatoriumuQuantityResponse,
  UpdateMaxEnsuiQuantityResponse,
  toMaxEnkaNatoriumuQuantity,
  toMaxEnsuiQuantity,
} from '@/models/apis/ensui/johaisetsuEnsuiPlantResponse';
import {
  MaxEnkaNatoriumuQuantity,
  MaxEnsuiQuantity,
} from '@/models/johaisetsu/johaisetsuCommon';

export default {
  index(params: JohaisetsuEnsuiPlantParams): Promise<AxiosResponse<EnsuiPlant[]>> {
    return axios.get(utils.getApiUrl('/johaisetsu_ensui_plants'), {
      params: params || {},
    });
  },
  downloadCSV(params: JohaisetsuEnsuiPlantParams): Promise<AxiosResponse<Blob>> {
    return axios.get(utils.getApiUrl(`/johaisetsu_ensui_plants/csv`), {
      params: params,
      responseType: 'blob',
    });
  },
  async updateMaxEnkaNatoriumuQuantity(
    id: number,
    params: UpdateMaxEnkaNatoriumuQuantityParams,
  ): Promise<MaxEnkaNatoriumuQuantity> {
    const { data } = await axios.put<UpdateMaxEnkaNatoriumuQuantityResponse>(
      utils.getApiUrl(`/johaisetsu_ensui_plants/${id}/max_enka_natoriumu_quantity`),
      params,
    );
    return toMaxEnkaNatoriumuQuantity(data);
  },
  async updateMaxEnsuiQuantity(
    id: number,
    params: UpdateMaxEnsuiQuantityParams,
  ): Promise<MaxEnsuiQuantity> {
    const { data } = await axios.put<UpdateMaxEnsuiQuantityResponse>(
      utils.getApiUrl(`/johaisetsu_ensui_plants/${id}/max_ensui_quantity`),
      params,
    );
    return toMaxEnsuiQuantity(data);
  },
};
